const authComponentsClasses = {
  container: 'flex items-center justify-center w-full',
  image: 'w-1/2 h-screen bg-cover bg-center',
  formContainer: 'flex flex-col items-center justify-center min-h-screen w-1/2',
  heading: 'text-3xl font-extrabold mb-16 text-center',
  form: 'border border-slate-700 bg-slate-800 rounded-md p-12 mb-8 w-50 text-white shadow-2xl',
  label: 'font-semibold text-xl',
  input: 'border p-2 mb-2 bg-slate-700 border-slate-600',
  button:
    'bg-blue-500 text-white py-2 px-4 rounded-md shadow hover:bg-blue-600 transition-colors duration-300 mt-4 font-semibold text-lg',
  error: 'text-red-500 text-sm mt-2',
  container2: 'flex flex-col items-center gap-2',
  button2:
    'bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow w-32 text-center',
}

export default authComponentsClasses
